import { platformBrowserDynamic }  from '@angular/platform-browser-dynamic';
import * as NgUpgrade from '@angular/upgrade/static';
import { enableProdMode, LOCALE_ID } from '@angular/core';

import { CfnModule } from './angular/cfn.module';
import { LoginModule } from './angular/login/login.module';
import { UrlHandlingStrategy } from '@angular/router';

import {
    isAppPage,
} from './app/helper/pages';
import { setUpLocationSync } from './angular/routing/cfn-routing.module';
import { loginModuleName } from './app/login/loginModule'
import { downgradeComponent } from '@angular/upgrade/static';
import { GuidanceLineIssueButtonComponent } from '@farmnet/fninbox-components';
import { LoginService } from './angular/login/services/login.service';
import { FarmnetModuleService } from './angular/routing/services/farmnet-module.service';
import { AngularJsLocationSyncService } from './angular/webapp-loader/service/angular-js-location-sync.service';
import { AngularLocationSyncService } from './angular/webapp-loader/service/angular-location-sync.service';
import { FnwNavigationService } from '@farmnet/webapp-loader-companion';

declare let angular: angular.IAngularStatic;
declare let window: any;

export default (locale: string) => {
    if (window.ENV === 'production') {
        enableProdMode();
    }
    const isApp = isAppPage();
    return platformBrowserDynamic([
        {
            provide: LOCALE_ID,
            useValue: locale
        }
    ]).bootstrapModule( !isApp ? LoginModule : CfnModule)
        .then(platformRef => {
            const upgrade = platformRef.injector.get(NgUpgrade.UpgradeModule) as NgUpgrade.UpgradeModule;

            const angularJsModule = !isApp ? loginModuleName : 'cfn';

            angular
                .module(angularJsModule)
                .factory('LoginService', NgUpgrade.downgradeInjectable(LoginService))
                .factory('farmnetModuleService', () => platformRef.injector.get(FarmnetModuleService))
                .factory('ng1NgXUrlHandlingStrategy', () => platformRef.injector.get(UrlHandlingStrategy))
                .factory('fnwNavigationService', () => platformRef.injector.get(FnwNavigationService))
                .directive('fninboxGuidanceLineIssueButton', downgradeComponent({
                    component: GuidanceLineIssueButtonComponent
                }));

            upgrade.bootstrap(document.documentElement, [angularJsModule], {
                strictDi: true
            });

            // routing is only used in app page
            if(isAppPage()) {
                setUpLocationSync(upgrade);

                const angularJsLocationSyncService: AngularJsLocationSyncService =  platformRef.injector.get(AngularJsLocationSyncService);
                platformRef.injector.get(AngularLocationSyncService).startLocationSync();
                angularJsLocationSyncService.startLocationSync();
                angularJsLocationSyncService.notifyWebappLoader();
            }
            return true;
        });
}
